/**
 * Global Imports
*/

import ls from 'local-storage';

/**
 * Root Imports
*/

import { TOKEN_NAME, TOKEN_TYPE } from '~/config/Token';

/**
 * Exports
*/

export const TokenStorage = {
  get: ()      => ls.get(TOKEN_NAME),
  set: (token) => ls.set(TOKEN_NAME, token),
  clear: ()    => ls.remove(TOKEN_NAME),
  type: ()     => TOKEN_TYPE
};